import { render, staticRenderFns } from "./EventSettings.vue?vue&type=template&id=58d0b338&scoped=true"
import script from "./EventSettings.vue?vue&type=script&lang=js"
export * from "./EventSettings.vue?vue&type=script&lang=js"
import style0 from "./EventSettings.vue?vue&type=style&index=0&id=58d0b338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d0b338",
  null
  
)

export default component.exports